export default __webpack_public_path__ + "atomic/_patterns/02-molecules/navigation-image-map/_navigation-image-map.twig";